import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components";
import { registerCajaCerradaNoticeHandler } from "@/utilities/caja-cerrada-notice-bridge";

export function CajaCerradaNoticeHost() {
  const { t } = useTranslation("components", { keyPrefix: "cajaCerrada" });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const resolveRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    return registerCajaCerradaNoticeHandler((noticeMessage) => {
      return new Promise<void>((resolve) => {
        setMessage(noticeMessage);
        resolveRef.current = resolve;
        setOpen(true);
      });
    });
  }, []);

  const handleConfirm = () => {
    setOpen(false);
    const resolve = resolveRef.current;
    resolveRef.current = null;
    resolve?.();
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && open) {
          handleConfirm();
        }
      }}
    >
      <DialogContent
        className="max-w-md"
        onPointerDownOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{t("title")}</DialogTitle>
          <DialogDescription className="pt-2 space-y-2 text-sm">
            <span className="block">{message}</span>
            <span className="block text-muted-foreground">{t("hint")}</span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button className="w-full sm:w-auto" onClick={handleConfirm}>
            {t("confirmButton")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
